export default {
  ctrl: {
    save: "Save",
    cancel: "Cancel",
    search: "Search",
    size: "Size",
    file: "File",
    timestamp: "Timestamp",
    name: "Name",
    user: "User",
    close: "Close",
    confirm: "Confirm",
    error: "Something went wrong!",
    errorCode: "Error code",
    remove: "Remove",
    selectCompetition: "Select competition",
    status: "Status",
    add: "Add",
    language: "Language",
    change: "Change",
    successfullySaved: "Saved successfully",
    export: "Export",
    delete: "Delete",
    total: "Skupno",
    submit: "Submit",
    next: "Next",
    back: "Back",
    ok: "Ok",
    select: "Select",
    edit: "Edit"
  },
  dashboard: {
    title: "Dashboard",
    shirts: "Shirts",
    competitionStart: "Competition start",
    competitionEnd: "Competition end"
  },
  lang: {
    'sl-SI': "Slovenian",
    'en-US': "English",
    'hr-HR': "Croatian"
  },
  langNative: {
    'sl-SI': "Slovensko",
    'en-US': "English",
    'hr-HR': "Hrvatski"
  },
  forms: {
    required: "Required",
    invalidemail: "Invalid e-mail"
  },
  login: {
    title: "Login",
    incorrect: "Your e-mail or password is incorrect",
    confirmationError: "There was an error while confirming your email.",
    confirmed: "Email successfully confirmed! You can now log in.",
    forgotPassword: "I forgot my password"
  },
  registration: {
    title: "Registration",
    required: "Required",
    invalidEmail: "Invalid email",
    passwordMismatch: "Passwords don't match",
    passwordLength: "Password must be at least 6 characters long",
    passwordNumerical: "Password must contain at least one digit",
    registrationSuccessful: "Registration successful. Check your inbox (Spam folder as well) for the confirmation message.",
    error: "There was an error with your registration."
  },
  "password-reset": {
    title: "Password reset",
    reset: "Reset",
    message: "Password reset link was sent to"
  },
  "new-password": {
    title: "Password change",
    changeError: "There was an error while changing your password.",
    changed: "Password successfully changed. You can now login.",
    change: "Change password"
  },
  competitors: {
    title: "Competitors",
    firstName: "Name",
    lastName: "Surname",
    department: "File department",
    gender: "Gender",
    email: "Email"
  },
  applications: {
    title: "Applications",
    profileNotFilled: "You have to enter all profile details",
    assignCategories: "Assign categories",
    clearCategories: "Clear categories"
  },
  application: {
    competition: "Competition",
    title: "Team name",
    type: "Application type",
    category: "Category",
    unassigned: "Unassigned",
    individual: "Individual",
    tandem: "Tandem",
    relay: "Relay",
    code: "Code",
    email: "Email",
    remarks: "Remarks",
    payment: "Payment",
    invoiceForDepartment: "Invoice for department",
    invoiceAddress: "Invoice address",
    taxNumber: "Tax number",
    amount: "Amount",
    reference: "Reference",
    confirmations: "Confirmations",
    events: "Events",
    competitors: "Competitors",
    confirmPayment: "Confirm payment",
    confirmPaymentText: "Do you want to confirm payment?",
    new: "New application",
    summary: "Summary",
    price: "Price",
    cantAddCompetitor: "This competitor is not registered in the system or doesn't have their profile completed.",
    noCycle: "Applications for the selected competition are currently closed.",
    submitTerms: "By pressing Submit you agree that the organizer may publish and process my personal data for the purposes of the competition in accordance with the law. Data is kept with the organizer of the competition.",
    failed: "There was an error while submitting your application.",
    duplicateError: "Application with these competitors already exists.",
    duplicateTitleError: "Application with this title already exists.",
    incomplete: "You must fill in all required fields.",
    confirmCancelText: "Do you want to cancel this application?",
    confirmCategoryChange: "Do you want to change category for this application?",
    remindParticipation: "Remind",
    remindParticipationConfirmation: "Do you want to remind participants to confirm their participation?",
    remindersSent: "Reminders sent",
    confirmDeleteText: "Do you want to delete this application?",
    noCycleForApplicationType: "Applications for this application type are currently closed.",
    unofficial: "Unofficial result"
  },
  payment: {
    receiver: "Receiver",
    address: "Address",
    bank: "Bank",
    subject: "Subject",
    instructions: "To complete your registration, you must pay the entry fee. Info for the payment is below. After the payment, upload the confirmation of the payment via the form below. Registration fee is returned only in the event of higher power.",
    uploadConfirmation: "Upload confirmation",
    uploadError: "There was an error while uploading the confirmation",
    assignCategoriesConfirmation: "Do you want to assign categories?",
    clearCategoriesConfirmation: "Do you want to clear assigned categories?"
  },
  competitor: {
    name: "Name",
    department: "Fire department",
    shirtSize: "Shirt size",
    shirt: "Shirt",
    participation: "Participation",
    checkedIn: "Checked-in",
    email: "Email",
    dateOfBirth: "Date of birth",
    address: "Address",
    country: "Country",
    telephone: "Telephone",
    bestTime: "Best time",
    applications: "Applications",
    alreadyCheckedin: "This competitor is already checkin for this competition",
    roles: "Roles"
  },
  profile: {
    title: "Profile",
    firstname: "First name",
    lastname: "Last name",
    email: "Email",
    dateofbirth: "Date of birth",
    gender: "Gender",
    address: "Address",
    telephone: "Telephone",
    password: "Password",
    repeatpassword: "Repeat password",
    male: "Male",
    female: "Female",
    search: "To add competitors enter email",
    saved: "Profile data saved"
  },
  events: {
    ParticipationConfirmed: "Participation confirmed",
    ApplicationFiled: "Application filed",
    PaymentUploaded: "Payment uploaded",
    PaymentConfirmed: "Payment confirmed",
    ApplicationCanceled: "Application canceled"
  },
  server: {
    title: "Server",
    requests: "Requests",
    logs: "Logs",
    requestsPerMinute: "Requests per minute",
    responseTime: "Response time",
    emailFilter: "Email filter",
    clients: "Clients"
  },
  competition: {
    title: "Competition",
    organizer: "Organizer",
    organizerAddress: "Organizer address"
  },
  applicationCycles: {
    title: "Application cycles",
    startTime: "Start",
    endTime: "End",
    amount: "Amount",
    paymentByTransfer: "Payment by transfer"
  },
  races: {
    title: "Races",
    race: "Race",
    name: "Title",
    previous: "Previous race",
    maximalRuns: "Maximal runs",
    assignStartNumbers: "Assign start numbers",
    evaluationSheets: "Evaluation sheets",
    chooseRed: "Choose red",
    chooseBlue: "Choose blue",
    publicDisplay: "Public",
    maximalNumberOfRuns: "Maximal number of runs",
    previousRace: "Previous race",
    startNumberOffset: "Start number offset",
    startList: "Start list",
    confirmRunDelete: "Do you want to delete selected runs?",
    announcement: "Announcement"
  },
  categories: {
    title: "Categories",
    order: "Order",
    label: "Label",
    name: "Name"
  },
  penalities: {
    title: "Penalities",
    description: "Description",
    discipline: "Discipline",
    penalityString: "Penality",
    amount: "Amount",
    totalAdditionalTime: "Additional time",
    removeConfirmText: "Do you want to remove this penality?",
    copyFromCompetition: "Copy from competition"
  },
  runs: {
    startNumber: "Start number",
    totalTime: "Total time",
    disqualification: "Disqualification",
    time: "Time",
    place: "Place",
    additionalTime: "Additional time"
  },
  contact: {
    title: "Contact"
  },
  results: {
    title: "Results",
    notReadyToStart: "Not ready to start"
  },
  role:{
    title: "Role"
  },
  referee:{
    title: "Referee",
    unsavedChangesMessage: "One of the runs have unsaved changes. Do you wish do proceed?"
  },
  messages: {
    messages: "Messages",
    message: "Message",
    title: "Title",
    text: "Text",
    start: "Start",
    end: "End",
    location: "Location",
    public: "Public",
    confirmRemove: "Do you want to delete this message?",
    showMap: "Show map"
  }
}
